<template>
    <div 
        class="body wv2-page"
        :class="{ 'quick-view-open': quickViewVisible }"
        :style="quickViewOffsetStyle"
    >
        <div class="wv2-main">
            <a-card class="page-card" :bordered="false" id="title-card">
                <template slot="title">
                    <a-breadcrumb separator=">">
                        <a-breadcrumb-item>
                        <router-link to="/cliente/monitores/cotacoes">
                            Home
                        </router-link>
                        </a-breadcrumb-item>

                        <a-breadcrumb-item>
                        <router-link to="/cliente/monitores/cotacoes">
                            Monitor de Cotação
                        </router-link>
                        </a-breadcrumb-item>

                        <a-breadcrumb-item class="order-page-title">
                            Comparativo de Preços
                        </a-breadcrumb-item>
                    </a-breadcrumb>
                </template>

                <template slot="extra">
                    <div class="wv2-actions">
                        <a-button
                            icon="sync"
                            :loading="refreshing_erp"
                            :disabled="refreshing_erp"
                            @click="refreshErpData"
                        >
                            Atualizar estoque/preço
                        </a-button>

                        <a-button
                            v-if="isPartialOrderRequest() && can('REQUEST_ORDER', 'CREATE')"
                            icon="lock"
                            title="A cotação está em pedido parcial: os vendedores ainda podem digitar o que não foi pedido."
                            @click="closePartialTyping"
                        >
                            Encerrar digitação
                        </a-button>

                        <a-button
                            v-if="canFreeze"
                            :type="freezed ? 'primary' : 'default'"
                            @click="toggleFreeze"
                        >
                            {{ freezed ? "Descongelar cotação" : "Congelar cotação" }}
                        </a-button>

                        <a-dropdown :trigger="['click']">
                            <a-button>
                                Outras Funções
                                <a-icon type="down" />
                            </a-button>

                            <a-menu slot="overlay">
                                <a-menu-item @click="dowloadReport">
                                    Comparativo excel
                                </a-menu-item>

                                <a-menu-item @click="generalReport">
                                    Relatório geral
                                </a-menu-item>

                                <a-menu-item @click="prices">
                                    Comparativos de preços
                                </a-menu-item>

                                <a-menu-item @click="generateOrders">
                                    Gerar pedidos
                                </a-menu-item>

                                <a-menu-item
                                    v-if="total_orders > 0"
                                    @click="exportOrder"
                                >
                                    Exportar pedido
                                </a-menu-item>

                                <a-menu-item
                                    v-if="isOrderCreated"
                                    @click="showRecreateRequestModalFunction"
                                >
                                    Reabrir cotação
                                </a-menu-item>

                                <a-menu-divider v-if="freezed" />

                                <a-menu-item
                                    v-if="freezed"
                                    @click="clearWinners"
                                >
                                    Remover vencedores
                                </a-menu-item>

                                <a-menu-item
                                    v-if="freezed"
                                    @click="excludeRequest"
                                    style="color: #ff4d4f;"
                                >
                                    Excluir cotação
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </div>
                </template>
            </a-card>

            <div class="wv2-tabs-row">
                <div class="wv2-tabs">
                    <span
                        v-for="tab in tabs"
                        :key="tab.key"
                        class="wv2-tab-group"
                    >
                        <span
                            v-if="tab.groupStart"
                            class="wv2-tab-divider"
                        ></span>
                        <button
                            class="wv2-tab"
                            :class="{
                                active: active_tab == tab.key,
                                disabled: tab.disabled,
                            }"
                            @click="open(tab)"
                        >
                            <span class="material-icons-outlined wv2-tab-icon">{{
                                tab.icon
                            }}</span>
                            {{ tab.label }}
                            <span
                                v-if="tab.badge"
                                class="wv2-tab-badge"
                                :class="tab.badgeClass"
                                >{{ tab.badge }}</span
                            >
                        </button>
                    </span>
                </div>
            </div>

            <div class="wv2-content">
                <cc-loader-full v-if="generating_orders" />

                <ComparativoTab
                    v-show="active_tab == 'COMPARATIVO'"
                    :products="products"
                    :total_items="total_items"
                    :is_loading="is_loading"
                    :filters="filters"
                    :filter_by_providers_options="filter_by_providers_options"
                    :filter_by_category_options="filter_by_category_options"
                    :storesArray="storesArray"
                    :my_store="myStore"
                    :page="page"
                    :total_pages="total_pages"
                    @update-filter="onUpdateFilter"
                    @clear-filters="onClearFilters"
                    @search="getProducts"
                    @change-page="changePage"
                    @toggle-winner="toggleWinner"
                    @giro="openProductQuickView"
                    @print="printComparativo"
                    @pre-orders-changed="syncAfterChange(['PRE_ORDERS', 'ORDERS'])"
                    @partial-order-done="afterPartialOrder"
                />

                <PreOrdersTab
                    ref="preOrdersTab"
                    v-if="pre_orders_visited"
                    v-show="active_tab == 'PRE_ORDERS'"
                    :pre_orders="pre_orders"
                    :is_loading_sellers="is_loading_sellers"
                    :compact="quickViewVisible"
                    @load-pre-orders="syncAfterChange(['COMPARATIVO', 'ORDERS'])"
                    @partial-order-done="afterPartialOrder"
                    @giro="openProductQuickView"
                    @cell-focus="handleMatrixCellFocus"
                />

                <ProductsTab
                    v-show="active_tab == 'PRODUCTS'"
                    @giro="openProductQuickView"
                    @count-changed="(count) => (products_tab_count = count)"
                />

                <RequisicoesTab
                    v-show="active_tab == 'REQUISITIONS'"
                    @count-changed="(count) => (requisicoes_tab_count = count)"
                />

                <OrdersTab v-if="orders_visited" v-show="active_tab == 'ORDERS'" ref="ordersTab" @order-cancelled="syncAfterChange(['COMPARATIVO', 'PRE_ORDERS'])" />

                <FornecedoresTab
                    v-if="active_tab == 'SUPPLIERS'"
                    :pagination="providerPagination"
                    :providers="providers"
                    :is_loading="is_loading_providers"
                    :filters="provider_filters"
                    @update-filter="onUpdateProviderFilter"
                    @search="loadFornecedores"
                    @export="exportProviders"
                    @clear-filters="clearProviderFilters"
                    @add-fornecedor="openAddFornecedorModal"
                    :status_options="providerStatusOptions"
                    :sort="providerSort"
                    :can_send_whatsapp="canSendWhatsapp"
                    :engagedProvidersCount="engagedProvidersCount"
                    :summary="providerSummary"
                    :show_totalizadores="showProviderTotalizadores"
                    @toggle-totalizadores="toggleProviderTotalizadores"
                    :total-without-filters="providers_count"
                    :id="id"
                />

                <AddFornecedorPickerModal
                    v-if="addFornecedorModal.open"
                    :id="id"
                    :exclude-ids="providers.map((p) => p.id_vendedor)"
                    @close="closeAddFornecedorModal"
                    @select="addFornecedor"
                />

                <GeneralRequestReport
                    v-if="active_tab == 'FULL_REPORT' && report_data"
                    :data="report_data"
                />

                <GeneralRequestReportWithLastOffer
                    v-if="active_tab == 'FULL_REPORT_WITH_LAST_OFFER' && report_data_with_last_offer"
                    :data="report_data_with_last_offer"
                />

                <ComingSoonTab
                    v-if="placeholderTab"
                    :title="placeholderTab.label"
                    :icon="placeholderTab.icon"
                />
                <ExportOrder
                    v-if="showExportOrder"
                    :visible="showExportOrder"
                    :cotId="id"
                    @close="showExportOrder = false"
                />
            </div>
            <ChangeQuotationDeadlineModal
                v-if="showRecreateRequestModal"
                :visible="showRecreateRequestModal"
                :close="() => (showRecreateRequestModal = false)"
            />
        </div>
        <product-quick-view-vertical
            :visible="quickViewVisible"
            :width="quickViewWidth"
            :product="quickViewProduct"

            :last-purchase="lastPurchase"
            :stock="stock"
            :last-sale="lastSale"
            :sales-analysis="salesAnalysis"

            :chart-labels="chartLabels"
            :sales-points="salesPoints"
            :purchase-points="purchasePoints"
            :sales-highlights="salesHighlights"
            :purchase-highlights="purchaseHighlights"

            :purchases="purchases"
            :network-sales="networkSales"
            :network-total="networkTotal"
            :stores="quickViewStores"
            :selected-store-id="selectedStoreId"
            :requested-quantity="quickViewStoreEntry && quickViewStoreEntry.requested_quantity"
            :has-navigation="hasQuickViewNavigation"
            :can-go-previous="canGoPreviousQuickViewProduct"
            :can-go-next="canGoNextQuickViewProduct"
            :current-index="quickViewSiblingIndex"
            :total-count="quickViewSiblings ? quickViewSiblings.length : 0"
            :read-only="quickViewReadonly"
            :quantity-locked="quickViewQuantityLocked"
            :data-unavailable="quickViewDataUnavailable"

            @close="closeProductQuickView"
            @change-store="handleStoreChange"
            @expand="openQuickViewWindow"
            @update-quantity="handleUpdateQuantity"
            @edit-packaging="openWrapModal"
            @previous-product="goToPreviousQuickViewProduct"
            @next-product="goToNextQuickViewProduct"

            :loading="quickViewLoading"
            :diagnostics-stores="diagnosticsStores"
            :updated-at="updatedAt"
        />

        <product-quick-view-window
            :visible="quickViewWindowVisible"
            :product="quickViewProduct"

            :last-purchase="lastPurchase"
            :stock="stock"
            :last-sale="lastSale"
            :sales-analysis="salesAnalysis"

            :sales-points="salesPoints"
            :purchase-points="purchasePoints"

            :purchases="purchases"
            :network-sales="networkSales"
            :network-total="networkTotal"
            :stores="quickViewStores"
            :selected-store-id="selectedStoreId"
            :requested-quantity="quickViewStoreEntry && quickViewStoreEntry.requested_quantity"
            :has-navigation="hasQuickViewNavigation"
            :can-go-previous="canGoPreviousQuickViewProduct"
            :can-go-next="canGoNextQuickViewProduct"
            :current-index="quickViewSiblingIndex"
            :total-count="quickViewSiblings ? quickViewSiblings.length : 0"
            :read-only="quickViewReadonly"
            :quantity-locked="quickViewQuantityLocked"
            :data-unavailable="quickViewDataUnavailable"

            @close="closeQuickViewWindow"
            @collapse="collapseQuickViewWindow"
            @change-store="handleStoreChange"
            @update-quantity="handleUpdateQuantity"
            @edit-packaging="openWrapModal"
            @previous-product="goToPreviousQuickViewProduct"
            @next-product="goToNextQuickViewProduct"

            :loading="quickViewLoading"
            :diagnostics-stores="diagnosticsStores"
            :updated-at="updatedAt"
        />

        <ProductWrapModal
            v-if="wrapModalVisible && wrapModalProduct"
            :product="wrapModalProduct"
            @close="closeWrapModal"
        />
    </div>
</template>

<script>
import QuotationService from "@/services/QuotationService";
import ProviderService from "@/services/ProviderService";
import RequestsService from "@/services/v2/requests.service";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import V3RequestsService from "@/services/v3/request.service";
import RequestProductService from "@/services/v3/requests/request-products.service";
import V3OrderService from "@/services/v3/order.service";
import StoreService from "@/services/v1/store.service";
import { perm_mixin } from "@/mixins/permission.mixin";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import { typingRemoteRequestControlMixin } from "@/mixins/typing-remote-request-controls.mixin";
import { mapState } from "vuex";
import { partial_order_mixin } from "@/mixins/partial-order.mixin";
import { is_partial_order_status } from "@/helpers/request-status";

import ComparativoTab from "./components/comparativo/_comparativo.tab.vue";
import PreOrdersTab from "./components/pre-orders-tab/_pre-orders.tab.vue";
import ProductsTab from "./components/products-tab/_products.tab.vue";
import RequisicoesTab from "./components/requisicoes-tab/_requisicoes.tab.vue";
import OrdersTab from "./components/orders-tab/_orders.tab.vue";
import FornecedoresTab from "./components/fornecedores-tab/_fornecedores.tab.vue";
import AddFornecedorPickerModal from "./components/fornecedores-tab/_add-fornecedor-picker.modal.vue";
import ComingSoonTab from "./components/placeholders/_coming-soon.tab.vue";
import ChangeQuotationDeadlineModal from "@/modals/requests/deadline/recreateRequest-ant";
import ExportOrder from "./components/modals/ExportOrder.vue";
import { productQuickViewMixin } from "@/mixins/product-quick-view.mixin";
import ProductQuickViewVertical from "./components/modals/ProductQuickViewVertical.vue";
import ProductQuickViewWindow from "./components/modals/ProductQuickViewWindow.vue";
import ProductWrapModal from "@/modals/product-wrap/product-wrap.modal.vue";
import GeneralRequestReport from "./components/general-report-tab/_general-report.tab.vue";
import GeneralRequestReportWithLastOffer from "@/components/partials/_general-report-with-last-offers.component.vue";

const TAB_KEYS = ["COMPARATIVO", "PRE_ORDERS", "REQUISITIONS", "ORDERS", "PRODUCTS", "SUPPLIERS"];

export default {
    name: "WinnersV2Page",
    mixins: [perm_mixin, loaderMixin, typingRemoteRequestControlMixin, productQuickViewMixin, partial_order_mixin],
    components: {
        ComparativoTab,
        PreOrdersTab,
        ProductsTab,
        RequisicoesTab,
        OrdersTab,
        FornecedoresTab,
        AddFornecedorPickerModal,
        ComingSoonTab,
        ChangeQuotationDeadlineModal,
        ExportOrder,
        ProductQuickViewVertical,
        ProductQuickViewWindow,
        ProductWrapModal,
        GeneralRequestReport,
        GeneralRequestReportWithLastOffer
    },
    props: {
        id: [String, Number],
    },
    data() {
        return {
            wrapModalVisible: false,
            wrapModalProduct: null,
            addFornecedorModal: { open: false },
            quickViewStoreEntry: null,
            storeNumberToId: {},
            matrixCellFocusTimer: null,

            allStores: [],
            engagedProvidersCount: undefined,
            providerSummary: null,
            showProviderTotalizadores: true,
            requisicoes_tab_count: undefined,
            providerSort: {
                field: "provider_name",
                order: "ascend",
            },
            providers_count: undefined,
            products_tab_count: undefined,
            providerPagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                locale: {
                items_per_page: '/ página'
                },
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} itens`,
            },
            showExportOrder: false,
            showRecreateRequestModal: false,
            showOptionSelect: false,
            report_data: null,
            report_data_with_last_offer: null,
            isOrderCreated: undefined,
            svc: new RequestsService(),
            service_v1: new QuotationService(),
            provider_svc: new ProviderService(),
            v3_svc: new V3RequestsService(),
            request_products_svc: new RequestProductService(),
            v3_order_svc: new V3OrderService(),
            active_tab: TAB_KEYS.includes(this.$route.query.tab) ? this.$route.query.tab : "COMPARATIVO",
            pre_orders_visited: this.$route.query.tab === "PRE_ORDERS",
            orders_visited: this.$route.query.tab === "ORDERS",
            stale_tabs: { COMPARATIVO: false, PRE_ORDERS: false, ORDERS: false },
            providers: [],
            is_loading_providers: true,
            placeholders: [
                { key: "OVERVIEW", label: "Visão geral", icon: "dashboard" },
                { key: "NEGOTIATION", label: "Negociação", icon: "handshake" },
                { key: "AUDIT", label: "Auditoria", icon: "history" },
            ],

            is_loading: true,
            is_loading_sellers: true,
            generating_orders: false,
            refreshing_erp: false,
            myStore: undefined,
            freezed: false,

            products: [],
            total_items: 0,
            page: 1,
            page_size: 30,
            filters: {
                description: "",
                provider: undefined,
                category: undefined,
                loja: undefined,
                has_observation: false,
                others_only: false,
                variation_price: false,
                selected_only: false,
                offers: undefined,
            },
            provider_filters: {
                status: undefined,
                has_offered_products: false,
                has_previous_offered_products: false,
            },
            filter_by_providers_options: [{ text: "TODOS", value: undefined }],
            filter_by_category_options: [{ text: "TODOS", value: undefined }],
            stores: [],
            storesArray: [],

            pre_orders: [],
            total_pre_orders: 0,
            total_orders: 0,
            providerStatusOptions: [
                {
                    label: "Não digitado",
                    value: "NOT_TYPED",
                },
                {
                    label: "Digitado",
                    value: "TYPED",
                },
                {
                    label: "Não ofertado",
                    value: "NOT_OFFERED",
                },
                {
                    label: "Pedido gerado",
                    value: "ORDERED",
                },
                {
                    label: "Sem pedido",
                    value: "NOT_ORDERED",
                },
                {
                    label: "Congelado",
                    value: "FROZEN",
                },
            ]
        };
    },
    computed: {
        ...mapState(["user"]),
        canSendWhatsapp() {
            return !this.freezed && !this.isOrderCreated;
        },
        total_pages() {
            return Math.ceil(this.total_items / this.page_size) || 1;
        },
        pending_products_count() {
            return this.products.filter((p) => !this.has_winner(p)).length;
        },
        tabs() {
            return [
                {
                    key: "COMPARATIVO",
                    label: "Comparativo de preços",
                    icon: "view_module",
                    badge: this.pending_products_count || undefined,
                    badgeClass: "warn",
                },
                {
                    key: "PRE_ORDERS",
                    label: "Pré-pedidos",
                    icon: "assignment_turned_in",
                    badge: this.total_pre_orders
                        ? this.to_currency(this.total_pre_orders)
                        : undefined,
                },
                {
                    key: "REQUISITIONS",
                    label: "Requisições",
                    icon: "assignment",
                    badge: this.requisicoes_tab_count || undefined,
                },
                {
                    key: "ORDERS",
                    label: "Pedidos",
                    icon: "local_shipping",
                    badge: this.total_orders
                        ? this.to_currency(this.total_orders)
                        : undefined,
                },
                {
                    key: "PRODUCTS",
                    label: "Produtos",
                    icon: "inventory_2",
                    badge: this.products_tab_count || undefined,
                    groupStart: true,
                },
                {
                    key: "SUPPLIERS",
                    label: "Fornecedores",
                    icon: "storefront",
                    badge: this.providers_count || undefined,
                },
                // ...this.placeholders.map((p) => ({ ...p, disabled: true })),
            ];
        },
        placeholderTab() {
            return this.placeholders.find((p) => p.key == this.active_tab);
        },
        canFreeze() {
            // Com pedido parcial já há pedidos: congelar não se aplica.
            const status = this.service_v1.getQuotationStatus(this.id);
            return (
                status != "PEDIDO GERADO" &&
                !is_partial_order_status(status) &&
                !this.isPartialOrderRequest()
            );
        },
        quickViewQuantityLocked() {
            return !!(this.quickViewProduct && this.quickViewProduct.has_order);
        },
    },
    watch: {
        storeNumberToId() {
            this.loadQuickViewStoreEntry();
        },
        active_tab(newTab) {
            if (newTab === "PRE_ORDERS" && !this.pre_orders_visited) {
                this.pre_orders_visited = true;
                this.stale_tabs.PRE_ORDERS = false;
            }
            if (newTab === "ORDERS" && !this.orders_visited) {
                this.orders_visited = true;
                this.stale_tabs.ORDERS = false;
            }
            if (this.stale_tabs[newTab]) {
                this.refreshTab(newTab);
            }
            // FULL_REPORT/FULL_REPORT_WITH_LAST_OFFER aren't real tabs (no
            // button for them, set programmatically from within Comparativo)
            // — only persist the ones the tab bar itself can navigate to.
            if (TAB_KEYS.includes(newTab) && this.$route.query.tab !== newTab) {
                this.$router
                    .replace({ query: { ...this.$route.query, tab: newTab } })
                    .catch(() => {});
            }
        },
    },
    methods: {
        async loadStoreNumberMap() {
            try {
                const response = await new StoreService().all(this.$store.state.user.cli_id);
                const lojas = (response.data && response.data.lojas) || [];

                this.allStores = lojas;

                this.storeNumberToId = lojas.reduce((map, loja) => {
                    map[String(loja.loj_numeroLoja)] = loja.loj_id;
                    return map;
                }, {});
            } catch (error) {
                ErrorHandlerService.handle(error, this.$store);
            }
        },
        async handleStoreChange(storeId) {
            this.selectedStoreId = storeId;

            await Promise.all([
                this.loadQuickViewData(),
                this.loadQuickViewStoreEntry(),
            ]);
        },
        async loadQuickViewStoreEntry() {
            this.quickViewStoreEntry = null;

            if (!this.quickViewProduct || !this.selectedStoreId) {
                return;
            }

            const storeId = this.storeNumberToId[String(this.selectedStoreId)] || this.selectedStoreId;

            try {
                const response = await this.request_products_svc.products(this.id, {
                    store_id: storeId,
                    per_page: 9999,
                });

                const rows = (response.data && response.data.data) || [];

                const match = rows.find(
                    (row) => String(row.pro_id) === String(this.quickViewProduct.id)
                );

                this.quickViewStoreEntry = match ? {
                    id: this.quickViewProduct.id,
                    store_id: storeId,
                    seller_id: this.quickViewProduct.seller_id,
                    requested_quantity: match.quantidade,
                } : null;
            } catch (error) {
                ErrorHandlerService.handle(error, this.$store);
            }
        },
        async loadStores(preferredStoreId = null) {
            if (!this.allStores.length) {
                await this.loadStoreNumberMap();
            }

            this.quickViewStores = this.allStores
                .map((loja) => ({
                    id_loja: loja.loj_numeroLoja,
                    loja_descricao: loja.loj_descricao,
                }))
                .sort((a, b) => Number(a.id_loja) - Number(b.id_loja));

            if (this.quickViewStores.length) {
                const matchedStore = preferredStoreId != null && this.quickViewStores.find(
                    (store) => String(store.id_loja) === String(preferredStoreId)
                );

                this.selectedStoreId = matchedStore
                    ? matchedStore.id_loja
                    : this.quickViewStores[0].id_loja;
            } else {
                this.selectedStoreId = null;
            }
        },
        async openProductQuickView(product, siblings, readOnly = false) {
            this.quickViewProduct = product;
            this.quickViewSiblings = Array.isArray(siblings) ? siblings : null;
            this.quickViewSiblingIndex = this.quickViewSiblings
                ? this.quickViewSiblings.findIndex((p) => p.id === product.id)
                : -1;
            this.quickViewReadonly = !!readOnly;

            await this.loadStores(product.store_id);

            if (!this.selectedStoreId) {
                return;
            }

            this.quickViewVisible = true;

            await Promise.all([
                this.loadQuickViewData(),
                this.loadQuickViewStoreEntry(),
            ]);
        },
        handleMatrixCellFocus(product, storeId, siblings) {
            if (!this.quickViewVisible && !this.quickViewWindowVisible) {
                return;
            }

            clearTimeout(this.matrixCellFocusTimer);

            this.matrixCellFocusTimer = setTimeout(() => {
                this.syncQuickViewToCell(product, storeId, siblings);
            }, 500);
        },
        async syncQuickViewToCell(product, storeId, siblings) {
            const isSameProduct = this.quickViewProduct && this.quickViewProduct.id === product.id;

            if (!isSameProduct) {
                this.quickViewProduct = product;
                this.quickViewSiblings = Array.isArray(siblings) ? siblings : null;
                this.quickViewSiblingIndex = this.quickViewSiblings
                    ? this.quickViewSiblings.findIndex((p) => p.id === product.id)
                    : -1;

                await this.loadStores(storeId);

                if (!this.selectedStoreId) {
                    return;
                }

                await Promise.all([
                    this.loadQuickViewData(),
                    this.loadQuickViewStoreEntry(),
                ]);
            } else if (String(this.selectedStoreId) !== String(storeId)) {
                const matchedStore = this.quickViewStores.find(
                    (store) => String(store.id_loja) === String(storeId)
                );

                if (matchedStore) {
                    await this.handleStoreChange(matchedStore.id_loja);
                }
            }
        },
        async goToQuickViewProductAt(index) {
            const nextProduct = this.quickViewSiblings[index];

            if (!nextProduct) {
                return;
            }

            this.quickViewSiblingIndex = index;
            this.quickViewProduct = nextProduct;

            await this.loadStores(this.selectedStoreId);

            if (!this.selectedStoreId) {
                return;
            }

            await Promise.all([
                this.loadQuickViewData(),
                this.loadQuickViewStoreEntry(),
            ]);
        },
        async handleUpdateQuantity(quantity) {
            const entry = this.quickViewStoreEntry;

            if (this.quickViewQuantityLocked) {
                this.snack("Esse produto já tem pedido gerado.", "error");
                return;
            }

            if (!entry || !entry.store_id || !entry.seller_id) {
                this.snack(
                    "Esse produto não tem pedido em andamento na loja selecionada.",
                    "error"
                );
                return;
            }

            try {
                await this.service_v1.sendQuantidade({
                    numerocotacao: this.$route.params.id,
                    quantidade: quantity || "0",
                    vendedor: entry.seller_id,
                    produto: entry.id,
                    loja: entry.store_id,
                });

                entry.requested_quantity = quantity;

                this.snack("Quantidade salva.");
                this.syncAfterChange(["COMPARATIVO", "PRE_ORDERS"]);
            } catch (error) {
                this.snack("Não foi possível salvar a quantidade.", "error");
                ErrorHandlerService.handle(error, this.$store);
            }
        },
        openWrapModal() {
            if (!this.quickViewProduct) {
                return;
            }

            this.wrapModalProduct = {
                ...this.quickViewProduct,
                descricaoProduto: this.quickViewProduct.name,
                embalagem: this.quickViewProduct.packing,
                idProduto: this.quickViewProduct.id,
            };

            this.wrapModalVisible = true;
        },
        closeWrapModal(payload) {
            this.wrapModalVisible = false;

            if (payload && payload.wrap && this.quickViewProduct) {
                this.quickViewProduct.packing = payload.wrap;
            }
        },
        buildProviderParams({ page, page_size } = {}) {
            const params = {};
            if (this.providerSort.field) {
                params.sort =
                    this.providerSort.order === "descend"
                        ? `-${this.providerSort.field}`
                        : this.providerSort.field;
            }

            if (page) {
                params.page = page;
            }

            if (page_size) {
                params.page_size = page_size;
            }

            if (this.provider_filters.status?.length) {
                params["filter[status]"] =
                    this.provider_filters.status.join(",");
            }

            if (this.provider_filters.has_offered_products) {
                params["filter[has_offered_products]"] = true;
            }

            if (this.provider_filters.has_previous_offered_products) {
                params["filter[has_previous_offered_products]"] = true;
            }

            return params;
        },
        exportProviders(type) {
            const params = this.buildProviderParams(this.provider_filters);

            return this.v3_svc
                .exportRequestCompetitors(this.id, type, params)
                .then((response) => {
                    const blob = new Blob([response.data]);

                    const url = window.URL.createObjectURL(blob);

                    const link = document.createElement("a");
                    link.href = url;

                    link.download =
                        type === "pdf"
                            ? "concorrentes.pdf"
                            : "concorrentes.xlsx";

                    link.click();

                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        clearProviderFilters() {
            this.provider_filters = {
                status: undefined,
                has_offered_products: false,
                has_previous_offered_products: false,
            };

            this.loadFornecedores();
        },
        onUpdateProviderFilter({ key, value }) {
            this.provider_filters[key] = value;
        },
        showRecreateRequestModalFunction() {
            this.showRecreateRequestModal = true;
        },
        download_report() {
            this.is_loading = true;
            this.svc
                .request_report(this.$route.params.id)
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: "application/vnd.ms-excel",
                    });
                    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
                    const reader = new FileReader();
                    const url = window.URL.createObjectURL(blob);
                    if (isIOS) {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onloadend = () => {
                            const base64data = reader.result;
                            const link = base64data;
                            link.href = base64data;
                            link.setAttribute(
                                "download",
                                `Mapa de Digitação ${this.$route.params.id}.xls`
                            );
                            document.body.appendChild(link);

                            const event = new MouseEvent("click", {
                                view: window,
                                bubles: true,
                                cancelable: true,
                            });
                            link.dispatchEvent(event);
                            document.body.removeChild(link);
                        };
                    } else {
                        const link = document.createElement("a");
                        link.href = url;
                        link.download = `Mapa de Digitações ${this.$route.params.id}.xls`;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                    setTimeout(() => {
                        window.URL.revokeObjectURL(url);
                    }, 100);
                    this.is_loading = false;
                })
                .catch((error) => {
                    this.is_loading = false;
                    console.error(error);
                });
        },
        dowloadReport() {
            this.download_report();
            this.showOptionSelect = false;
        },
        generalReport() {
            this.active_tab = "FULL_REPORT";
            this.closeProductQuickView();
            this.closeQuickViewWindow();
            this.showOptionSelect = false;
            this.report_data = null;
            this.v3_svc
                .general_request_report(this.id)
                .then((response) => {
                    this.report_data = response.data;
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        prices() {
            this.active_tab = "FULL_REPORT_WITH_LAST_OFFER";
            this.closeProductQuickView();
            this.closeQuickViewWindow();
            this.showOptionSelect = false;
            this.report_data_with_last_offer = null;
            this.v3_svc
                .general_request_report(this.id)
                .then((response) => {
                    this.report_data_with_last_offer = response.data;
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        generateOrders() {
            this.showOptionSelect = false;
            if (this.partialOrdersEnabled()) return this.generatePartialOrders();
            this.$swal
                .fire({
                    title: "Gerar pedidos?",
                    text: "Os pedidos serão criados a partir dos vencedores da cotação.",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim, gerar pedidos.",
                    cancelButtonText: "Cancelar",
                })
                .then((result) => {
                    if (!result.value && !result.isConfirmed) return;

                    this.is_loading = true;
                    this.generating_orders = true;
                    this.v3_svc
                        .generate_orders(this.$route.params.id)
                        .then((response) => {
                            const total = Array.isArray(response.data)
                                ? response.data.length
                                : 0;
                            const message = total
                                ? `${total} pedido(s) gerado(s) com sucesso.`
                                : "Pedidos gerados com sucesso.";

                            this.snack(message, "success");
                            this.open({ key: "ORDERS" });
                            this.syncAfterChange(["COMPARATIVO", "PRE_ORDERS", "ORDERS"]);
                        })
                        .catch((error) => {
                            const data = error.response && error.response.data;
                            const isTimeout = error.code === "ECONNABORTED";
                            const message =
                                (isTimeout &&
                                    "A geração de pedidos está demorando mais que o esperado. Verifique a aba Pedidos antes de tentar novamente, para evitar pedidos duplicados.") ||
                                (data && (data.mensagem || data.message || data.error)) ||
                                (typeof data === "string" ? data : null) ||
                                "Não foi possível gerar os pedidos.";

                            this.snack(message, "error");
                            ErrorHandlerService.handle(error, this.$store);
                        })
                        .finally(() => {
                            this.is_loading = false;
                            this.generating_orders = false;
                        });
                });
        },
        /**
         * "Gerar pedidos" com pedido parcial (CLUB-1443): todas as linhas
         * vencedoras ainda não pedidas, em pedidos novos.
         */
        generatePartialOrders() {
            return this.partial_order_round(
                this.id,
                {},
                {
                    title: "Gerar pedidos?",
                    text: "Os pedidos serão criados a partir dos vencedores ainda não pedidos da cotação.",
                    confirmButtonText: "Sim, gerar pedidos.",
                },
                {
                    start: () => {
                        this.is_loading = true;
                        this.generating_orders = true;
                    },
                    finish: () => {
                        this.is_loading = false;
                        this.generating_orders = false;
                    },
                }
            ).then((data) => {
                this.afterPartialOrder();
                if (data) this.open({ key: "ORDERS" });
                this.syncAfterChange(["COMPARATIVO", "PRE_ORDERS", "ORDERS"]);
            });
        },
        /** Depois de uma rodada: o status pode ter virado 4 (digitação encerrada). */
        afterPartialOrder() {
            return this.load_partial_request_status(this.id).then((status) => {
                if (Number(status) === 4) this.isOrderCreated = true;
            });
        },
        closePartialTyping() {
            this.close_partial_typing(this.id).then((closed) => {
                if (closed) this.isOrderCreated = true;
                this.load_partial_request_status(this.id);
                this.syncAfterChange(["COMPARATIVO", "PRE_ORDERS", "ORDERS"]);
            });
        },
        refreshErpData() {
            this.refreshing_erp = true;
            this.v3_svc
                .refresh_erp_data(this.id)
                .then((response) => response.data)
                .then((data) => {
                    const updated = (data && data.products ? data.products.length : 0);
                    this.snack(
                        updated
                            ? `Estoque e preço atualizados para ${updated} produto(s).`
                            : "Nenhum produto da cotação foi encontrado no ERP."
                    );
                    this.syncAfterChange(["COMPARATIVO", "PRE_ORDERS"]);
                })
                .catch((error) => {
                    this.snack("Não foi possível atualizar estoque e preço.", "error");
                    ErrorHandlerService.handle(error, this.$store);
                })
                .finally(() => {
                    this.refreshing_erp = false;
                });
        },
        exportOrder() {
            this.showOptionSelect = false;
            // this.is_loading = true
            // this.v3_svc.ExportOrder(this.$route.params.id).then(resp=>{
            //     var FileSaver = require('file-saver');
            //     var blob = new Blob([resp.data], {type: "text/plain;charset=utf-8"});
            //     this.is_loading = false
            //     FileSaver.saveAs(blob, `Relatorio-${this.$route.params.id}.csv`);
            // })
            this.showExportOrder = true;
        },
        clearWinners() {
            if (this.freezed) {
                this.$swal
                    .fire({
                        title: "Esta operacao removerá toda a seleção de compra , Deseja prosseguir?",
                        text: "Sua seleção será removida.",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Sim, remover todos!",
                    })
                    .then((result) => {
                        if (result.value) {
                            this.is_loading = true;
                            this.service_v1
                                .removeWinners(this.$route.params.id)
                                .then((response) => response.data)
                                .then((data) => {
                                    if (
                                        data.status ==
                                        CONSTANTS.REQUEST_CODE_SUCCESS
                                    ) {
                                        this.syncAfterChange(["COMPARATIVO", "PRE_ORDERS"]);
                                        this.$swal.fire(
                                            "Sucesso!",
                                            "Operação realizada com sucesso.",
                                            "success"
                                        );
                                    }
                                    this.is_loading = false;
                                })
                                .catch((error) => {
                                    this.is_loading = false;
                                    ErrorHandlerService.handle(
                                        error,
                                        this.$store
                                    );
                                });
                        }
                    });
            }
        },
        excludeRequest() {
            this.$swal
                .fire({
                    title: "Tem certeza que deseja excluir a cotação?",
                    text: "Sua cotação será cancelado!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim, excluir cotação.",
                })
                .then((response) => {
                    if (!response.isConfirmed) return;
                    this.is_loading = true;
                    this.service_v1
                        .excludeQuotation(this.id)
                        .then(() => {
                            this.is_loading = false;
                            this.goBack();
                        })
                        .catch((error) => {
                            this.is_loading = false;
                            this.snack(
                                "Desculpe, não foi possivel excluir a cotação.",
                                "error"
                            );
                        });
                });
        },
        to_currency(value) {
            return this.$options.filters.currency(value);
        },
        open(tab) {
            this.active_tab = tab.key;
            this.closeProductQuickView();
            this.closeQuickViewWindow();
        },
        has_winner(product) {
            return (product.vencedores || []).some(
                (v) => v.vencedor_quantidade > 0
            );
        },
        onUpdateFilter({ key, value }) {
            this.$set(this.filters, key, value);
            this.page = 1;
        },
        onUpdateProviderFilter({ key, value }) {
            this.$set(this.provider_filters, key, value);
            this.page = 1;
        },
        onClearFilters() {
            this.filters.description = "";
            this.filters.provider = undefined;
            this.filters.category = undefined;
            this.filters.loja = this.myStore ? this.filters.loja : undefined;
            this.filters.has_observation = false;
            this.filters.others_only = false;
            this.filters.variation_price = false;
            this.filters.selected_only = false;
            this.filters.offers = undefined;

            this.page = 1;
            this.getProducts();
        },
        changePage(page) {
            this.page = page;
            this.getProducts();
        },

        listParam(values) {
            return values?.length ? values.join(",") : undefined;
        },
        productsQueryParams(overrides = {}) {
            return {
                page: this.page,
                page_size: this.page_size,
                "filter[description]": this.filters.description || undefined,
                "filter[provider]": this.listParam(this.filters.provider),
                "filter[category]": this.listParam(this.filters.category),
                "filter[store]": this.filters.loja || undefined,
                "filter[has_observation]": this.filters.has_observation ? 1 : undefined,
                "filter[others_only]": this.filters.others_only ? 1 : undefined,
                "filter[variation_price]": this.filters.variation_price ? 1 : undefined,
                "filter[purchased_only]": this.filters.selected_only ? 1 : undefined,
                "filter[offers]": this.filters.offers || undefined,
                // LEGACY: kyojin antiga só lê os parâmetros soltos; a nova prefere o filter[...] quando vêm os dois. Remover quando a kyojin com Spatie no comparativo estiver em produção.
                description: this.filters.description,
                provider: this.listParam(this.filters.provider),
                has_observation: this.filters.has_observation ? 1 : 0,
                others_only: this.filters.others_only ? 1 : 0,
                variation_price: this.filters.variation_price ? 1 : 0,
                category: this.listParam(this.filters.category),
                store: this.filters.loja || undefined,
                purchased_only: this.filters.selected_only ? 1 : 0,
                ...overrides,
            };
        },
        toComparativoProduct(product) {
            const packing = product.packing || "";
            const erpPrice = Number(product.erp_last_purchase_price) > 0 ? Number(product.erp_last_purchase_price) : null;
            const lastPurchase = erpPrice != null
                ? { ...(product.last_purchase || {}), price: erpPrice }
                : product.last_purchase;

            return {
                prod_id: product.product_id,
                pro_id: product.product_id,
                descricaoProduto: product.description,
                embalagem: product.packing,
                qtd_embalagem: product.is_generic ? 0 : packing.split(" ")[1] || packing,
                codEan: product.ean,
                pro_codInterno: product.internal_code,
                unidade_compra: product.unit,
                quantidadeCotacao: product.quantity,
                replenishment_strategy: product.replenishment_strategy,
                flag_generico: product.is_generic ? 1 : 0,
                pro_principal: product.main_product_id,
                cot_condicao_pagamento: product.request_payment_condition,
                purchase_status: product.purchase_status,
                last_purchase: lastPurchase
                    ? { valor: lastPurchase.price, data_geracao: lastPurchase.date }
                    : undefined,
                vencedores: (product.offers || []).map((offer) => ({
                    idVendedor: offer.seller_id,
                    idFornecedor: offer.provider_id,
                    pro_id: offer.id,
                    nomeFornecedor: offer.provider_name,
                    nomeVendedor: offer.seller_name,
                    pro_observacao: offer.brand,
                    forma: offer.payment_condition,
                    data_entrega: offer.expected_delivery_date,
                    valor: offer.offer_price != null ? Number(offer.offer_price) : null,
                    embalagem: product.is_generic ? offer.offer_quantity : offer.packing,
                    observacao: offer.observations,
                    quantidade: offer.quantity_to_buy || 0,
                    vencedor_quantidade: offer.is_winner_in_scope ? 1 : 0,
                    qtdPedido: offer.has_order ? 1 : 0,
                })),
            };
        },
        getProducts() {
            this.is_loading = true;
            this.cancelSearch();
            this.v3_svc
                .comparison(
                    this.id,
                    this.productsQueryParams(),
                    this.cancelSource ? this.cancelSource.token : null
                )
                .then((response) => response.data)
                .then((data) => {
                    const rows = data.data || [];
                    // LEGACY: kyojin antiga devolve /comparison sem purchase_status/quantity_to_buy/has_order; cai no endpoint legado. Remover quando a kyojin com esses campos estiver em produção.
                    if (rows.length && !("purchase_status" in rows[0])) return this.getLegacyProducts();
                    this.products = rows.map(this.toComparativoProduct);
                    this.total_items = data.meta ? data.meta.total : 0;
                    this.is_loading = false;
                })
                .catch((error) => {
                    this.is_loading = false;
                    if (!error || error.__CANCEL__) return;
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        // LEGACY: fallback para a kyojin sem os campos novos do /comparison (ver getProducts). Remover quando a kyojin com esses campos estiver em produção.
        getLegacyProducts() {
            return this.svc
                .request_products_with_offers(
                    this.id,
                    {
                        product_filter: this.filters.description,
                        page: this.page,
                        page_size: this.page_size,
                        fornecedor: this.listParam(this.filters.provider) || "",
                        imprimir: false,
                        obs_only: this.filters.has_observation,
                        others_only: this.filters.others_only,
                        variation_only: this.filters.variation_price,
                        category_id: this.listParam(this.filters.category) || "",
                        loja: this.filters.loja,
                        selected_only: this.filters.selected_only ? 1 : 0,
                    },
                    this.cancelSource ? this.cancelSource.token : null
                )
                .then((response) => response.data)
                .then((data) => {
                    data.produtos.forEach((product) => {
                        product.purchase_status = (product.vencedores || []).some((v) => v.qtdPedido > 0)
                            ? "ORDERED"
                            : "NOT_ORDERED";
                    });
                    this.products = data.produtos;
                    this.total_items = data.total;
                    this.is_loading = false;
                });
        },
        printComparativo() {
            this.is_loading = true;
            this.v3_svc
                .download_comparativo_pdf(this.id)
                .then((response) => {
                    this.is_loading = false;
                    const blob = new Blob([response.data], {
                        type: "application/pdf",
                    });
                    const url = window.URL.createObjectURL(blob);
                    const isIOS = /ipad|iphone|ipod/.test(
                        navigator.userAgent.toLowerCase()
                    );

                    if (isIOS) {
                        window.open(url, "_blank");
                    } else {
                        const link = document.createElement("a");
                        link.href = url;
                        link.download = `comparativo-${this.id}.pdf`;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }

                    setTimeout(() => {
                        window.URL.revokeObjectURL(url);
                    }, 1000);
                })
                .catch((error) => {
                    this.is_loading = false;
                    this.snack(
                        "Não foi possível gerar o PDF do comparativo.",
                        "error"
                    );
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        getAllProviders() {
            return this.provider_svc
                .list(this.id)
                .then((response) => response.data)
                .then((data) => {
                    this.filter_by_providers_options = [{ text: "TODOS", value: undefined }];

                    data.fornecedores.forEach((fornecedor) => {
                        this.filter_by_providers_options.push({
                            text: fornecedor.nomeFornecedor,
                            value: fornecedor.idFornecedor,
                        });
                    });
                })
                .catch((error) =>
                    ErrorHandlerService.handle(error, this.$store)
                );
        },
        loadCategories() {
            this.service_v1
                .getCategoriasCotacao(this.id)
                .then((response) => response.data)
                .then((data) => {
                    this.filter_by_category_options = [];
                    data.categorias.forEach((c) =>
                        this.filter_by_category_options.push({
                            text: c.cat_descricao,
                            value: c.cat_id,
                        })
                    );
                });
        },
        load_stores() {
            this.service_v1
                .getStoresClient()
                .then((response) => response.data)
                .then((data) => {
                    this.stores = data.requisitantes;
                    this.storesArray = [];
                    this.stores.forEach((el) => {
                        this.storesArray.push({
                            text: (el.loj_nomeFantasia || "").toUpperCase(),
                            value: el.loj_id,
                        });
                    });

                    if (this.myStore) {
                        const mine = this.stores.find(
                            (s) => s.loj_id == this.myStore
                        );
                        if (mine) this.filters.loja = mine.loj_id;
                    }
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                })
                .finally(() => {
                    this.getProducts();
                });
        },
        syncAfterChange(tabs) {
            this.loadPreOrders();
            this.loadOrdersTotal();
            tabs.forEach((tab) => {
                if (this.active_tab === tab) {
                    this.refreshTab(tab);
                } else {
                    this.stale_tabs[tab] = true;
                }
            });
        },
        refreshTab(tab) {
            this.stale_tabs[tab] = false;
            if (tab === "COMPARATIVO") this.getProducts();
            if (tab === "PRE_ORDERS" && this.$refs.preOrdersTab) this.$refs.preOrdersTab.loadFlatProducts();
            if (tab === "ORDERS" && this.$refs.ordersTab) this.$refs.ordersTab.reload();
        },
        /**
         * Pré-pedidos come from the v3 endpoint, which returns a flat
         * pre_orders[] (one row per loja+vendedor+fornecedor) plus a meta block.
         *
         * The old getLojasFornecedores returned pending AND already-ordered rows
         * together, so this page summed both badges from the one payload. The v3
         * endpoint returns pending rows only — already-ordered ones are filtered
         * out server-side by tbl_cotacao_produto_vendedor.status — so the Pedidos
         * badge now has its own source (loadOrdersTotal below). Do not try to
         * derive it from pre_orders again; the data is not there.
         */
        loadPreOrders() {
            this.is_loading_sellers = true;
            return this.v3_svc
                .pre_orders(this.id)
                .then((response) => response.data)
                .then((data) => {
                    this.pre_orders = data.pre_orders || [];
                    // meta.total is computed server-side over the same rows
                    this.total_pre_orders = data.meta ? data.meta.total : 0;
                    this.is_loading_sellers = false;
                })
                .catch((error) => {
                    this.is_loading_sellers = false;
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        /**
         * Value already ordered for this cotação, for the Pedidos tab badge.
         * Separate call because the pré-pedidos endpoint deliberately no longer
         * carries ordered rows.
         */
        loadOrdersTotal() {
            return this.v3_order_svc
                .summary({ "filter[numerocotacao]": this.id })
                .then((response) => response.data)
                .then((data) => {
                    this.total_orders = data && data.valor_total ? data.valor_total : 0;
                })
                .catch(() => {
                    // A missing badge is preferable to blocking the tab; the
                    // Pedidos tab loads its own rows regardless.
                    this.total_orders = 0;
                });
        },
        loadFornecedores({
            pagination = this.providerPagination,
            sorter = this.providerSort,
        } = {}) {
            this.is_loading_providers = true;
            this.providerSort = sorter;

            if (this.showProviderTotalizadores) this.loadProviderSummary();

            return this.v3_svc.getRequestCompetitors(
                this.id,
                this.buildProviderParams({
                    page: pagination.current,
                    page_size: pagination.pageSize,
                })
            )
            .then(({ data }) => {
                this.providers = data.data;

                this.providerPagination = {
                    ...this.providerPagination,
                    current: data.meta.current_page,
                    pageSize: data.meta.per_page,
                    total: data.meta.total,
                };

                this.providers_count = data.total_without_filters;
                this.engagedProvidersCount = data.engaged_count;

                this.is_loading_providers = false;
            })
            .catch((error) => {
                ErrorHandlerService.handle(error, this.$store);
            })
            .finally(() => {
                this.is_loading_providers = false;
            });
        },
        loadProviderSummary() {
            return this.v3_svc
                .getRequestCompetitorsSummary(this.id, this.buildProviderParams())
                .then(({ data }) => {
                    this.providerSummary = data;
                })
                .catch((error) => {
                    // LEGACY: kyojin sem /competitors/summary responde 404 e a tab cai nos 2 cards antigos. Remover quando o back com summary estiver em produção.
                    if (error.response && error.response.status === 404) {
                        this.providerSummary = null;
                        return;
                    }
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        toggleProviderTotalizadores() {
            if (!this.showProviderTotalizadores) this.loadProviderSummary();
            this.showProviderTotalizadores = !this.showProviderTotalizadores;
        },
        openAddFornecedorModal() {
            this.addFornecedorModal.open = true;
        },
        closeAddFornecedorModal() {
            this.addFornecedorModal.open = false;
        },
        /**
         * A tab lê os fornecedores pelo kyojin (getRequestCompetitors), mas
         * adicionar um fornecedor à cotação ainda só existe no backend legado
         * (sellers/add). Por isso a escrita usa this.svc (v2) e, no sucesso,
         * recarrega a lista via loadFornecedores para vir com os dados que a
         * tab espera (kyojin).
         */
        addFornecedor(seller) {
            return this.svc
                .add_seller(this.id, {
                    cot_id: this.id,
                    vendedor_id: seller.usu_id,
                })
                .then(() => {
                    this.closeAddFornecedorModal();
                    this.$swal.fire("Sucesso!", "Fornecedor adicionado à cotação.", "success");
                    this.loadFornecedores();
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                });
        },

        toggleWinner({ winner, product }) {
            const loja = this.myStore || this.filters.loja;
            const seller_id = winner.idVendedor;
            const is_winner = winner.vencedor_quantidade > 0;
            this.$set(winner, "is_loading", true);
            this.service_v1
                .toggleQuotationWinner(
                    this.id,
                    loja,
                    winner.pro_id,
                    seller_id,
                    !is_winner
                )
                .then((response) => response.data)
                .then(() => {
                    this.$set(winner, "is_loading", false);
                    this.$set(
                        winner,
                        "vencedor_quantidade",
                        !is_winner ? 1 : 0
                    );
                    this.syncAfterChange(["PRE_ORDERS"]);
                })
                .catch((error) => {
                    this.$set(winner, "is_loading", false);
                    this.snack(
                        "Não foi possível atualizar o vencedor.",
                        "error"
                    );
                    ErrorHandlerService.handle(error, this.$store);
                });
        },

        toggleFreeze() {
            if (this.freezed) {
                this.confirm_action({
                    message: "Descongelar esta cotação?",
                    confirm_text: "Sim, descongelar",
                    callback: () => {
                        this.service_v1.unfreeze(this.id).then(() => {
                            this.freezed = false;
                            this.snack("Cotação descongelada.");
                        });
                    },
                });
            } else {
                this.confirm_action({
                    message: "Congelar esta cotação?",
                    subtitle:
                        "Fornecedores não poderão mais enviar novas ofertas.",
                    confirm_text: "Sim, congelar",
                    callback: () => {
                        this.service_v1.freeze(this.id).then(() => {
                            this.freezed = true;
                            this.snack("Cotação congelada.");
                        });
                    },
                });
            }
        },
    },
    created() {
        this.perms.forEach((element) => {
            if (element.resource == "MY_COMPANY" && element.action == "READ") {
                this.myStore = this.user.store_id;
            }
        });

        const status = this.service_v1.getQuotationStatus(this.id);
        this.freezed =
            status != null ? status.toLowerCase() == "congelada" : false;
        this.isOrderCreated = status == "PEDIDO GERADO";
        // Status 16 vem do kyojin (só com o recurso de pedido parcial).
        this.load_partial_request_status(this.id);
        this.getAllProviders();
        this.loadCategories();
        this.load_stores();
        this.loadPreOrders();
        this.loadOrdersTotal();
        this.loadFornecedores();
        this.loadStoreNumberMap();
    },
};
</script>

<style lang="scss" scoped>
.wv2-page {
    --pri: var(--primary-color);
    --pri-hover: var(--primary-color);
    --pri-bg: var(--primary-color-opacity, rgba(232, 96, 44, 0.1));
    --pri-border: var(--primary-color);
    overflow-x: hidden;
    background: #fff;
    font-family: "DM Sans", sans-serif;
    box-sizing: border-box;
    position: relative;
    max-width: 100%;
    min-width: 0;
    --quick-view-width: 500px;
    padding: 0;
}
// .wv2-page.quick-view-open {
//     padding-right: var(--quick-view-width);
// }
.wv2-page.quick-view-open {
    padding-right: var(--quick-view-width);
    box-sizing: border-box;
}

.wv2-page > * {
    min-width: 0;
}

.wv2-main {
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;
    transition: width 0.3s ease;
}

.wv2-content {
    min-width: 0;
    max-width: 100%;
    /* overflow-x: auto; */
}

.page-card {
    margin-bottom: 10px;
    width: 100%;
}
.wv2-tabs-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    border-bottom: 1px solid #f0f0f0;
}

.wv2-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.wv2-tabs {
    display: flex;
    flex-wrap: nowrap;
    align-items: stretch;
    gap: 0;
    padding: 0 16px;
    overflow-x: auto;
    margin-top: 8px;
}
.wv2-tab-group {
    display: contents;
}
.wv2-tab-divider {
    flex-shrink: 0;
    width: 1px;
    margin: 8px 8px;
    background: #e8e8e8;
}
.wv2-tab {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 52px;
    padding: 0 10px;
    margin-right: 8px;
    border: none;
    border-bottom: 2px solid transparent;
    background: none;
    font-size: 13px;
    font-weight: 500;
    color: #595959;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        color: var(--pri);
    }
    &.active {
        color: var(--pri);
        border-bottom-color: var(--pri);
        font-weight: 600;
    }
    &.disabled {
        color: #bfbfbf;
        cursor: not-allowed;
    }
    &.disabled:hover {
        color: #bfbfbf;
    }
}
.wv2-tab-icon {
    font-size: 18px !important;
}
.wv2-tab-badge {
    font-size: 11px;
    font-weight: 700;
    background: var(--pri-bg);
    color: var(--pri);
    border: 1px solid var(--pri);
    border-radius: 999px;
    padding: 0 7px;
    line-height: 16px;

    &.warn {
        background: #fff7e6;
        color: #d46b08;
        border-color: #ffd591;
    }
}
</style>
